import { useEffect, useState } from "react";
// routes
import Router from "./routes";
// components
// import NotistackProvider from "./components/NotistackProvider";
import { NotificationListProvider } from "./contexts/NotificationContext";
import { CartListProvider } from "./contexts/CartContext";
import { WishListProvider } from "./contexts/WishListContext";
import { CategoriesProvider } from "./contexts/CategoriesContext";
import { CompareListProvider } from "./contexts/CompareContext";

//----------------------------------------------------------------------

function App() {
  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);
  return (
    <>
      {/* <NotistackProvider> */}
      <CategoriesProvider>
        <NotificationListProvider>
          <CartListProvider>
            <WishListProvider>
              <CompareListProvider>
                <Router />
              </CompareListProvider>
            </WishListProvider>
          </CartListProvider>
        </NotificationListProvider>
      </CategoriesProvider>
      {/* </NotistackProvider> */}
    </>
  );
}

export default App;
